import sanitizeHtml from "sanitize-html";

/**
 * Sanitizes a comment by removing all HTML tags except for <mention> tags.
 *
 * This function temporarily retains <mention> tags in the input comment,
 * removes all other HTML tags, and then returns the sanitized text.
 *
 * @param comment The input comment string containing HTML and <mention> tags.
 * @returns The sanitized comment string with only <mention> tags preserved.
 */
export function sanitizeComment(htmlComment: string): string {
  // Replace closing </p> tags with newline characters (\n)
  const textWithLineBreaks = htmlComment.replace(/<\/p>/g, "</p>\n");
  // Parse HTML
  const result = sanitizeHtml(textWithLineBreaks, {
    allowedTags: ["mention"],
    allowedAttributes: {
      mention: ["data-email", "data-id", "data-name"],
    },
    textFilter: function (text, tagName) {
      // remove @ from mentions added in by tiptap
      if (["mention"].indexOf(tagName) > -1) {
        return text.replace(/@/g, "");
      }
      return text;
    },
  });
  return result;
}
